export default __webpack_public_path__ + "static/media/magnifying-glass.2c5b2dac.png";